type ComponentType = 'phone' | 'phone_v2' | 'email_v2' | 'call_me' | 'call_me_v2' | 'live_chat' | 'live_chat_v2' | 'whatsapp'

export interface HCConfig {
  [locale: string]: HCConfigContent
}

export interface HCConfigContent {
  domain: string
  proadvantageProgram?: boolean
  contactUsComponents: ComponentType[]
}

export const HC_CONFIG: HCConfig = {
  'en-au': {
    domain: 'https://www.vistaprint.com.au',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'en-nz': {
    domain: 'https://www.vistaprint.co.nz',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'en-sg': {
    domain: 'https://www.vistaprint.sg',
    contactUsComponents: ['phone_v2', 'email_v2', 'live_chat_v2'],
  },
  'en-ie': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'pt-pt': {
    domain: 'https://www.vistaprint.pt',
    contactUsComponents: ['phone_v2', 'call_me_v2', 'email_v2'],
  },
  'es-es': {
    domain: 'https://www.vistaprint.es',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'live_chat_v2'],
  },
  'en-in': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2'],
  },
  'en-us': {
    domain: 'https://www.vistaprint.com',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'en-gb': {
    domain: 'https://www.vistaprint.co.uk',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2', 'whatsapp'],
  },
  'it-it': {
    domain: 'https://www.vistaprint.it',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'live_chat_v2'],
  },
  'nl-nl': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'nl-be': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'live_chat_v2'],
  },
  'fr-be': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'live_chat_v2'],
  },
  'sv-se': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'nb-no': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'fi-fi': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'fr-fr': {
    domain: 'https://www.vistaprint.fr',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'live_chat_v2'],
  },
  'da-dk': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'fr-ca': {
    domain: 'https://www.vistaprint.ca',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'en-ca': {
    domain: 'https://www.vistaprint.ca',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'de-de': {
    domain: 'https://www.vistaprint.ie',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'live_chat_v2', 'whatsapp'],
  },
  'de-at': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'live_chat_v2'],
  },
  'fr-ch': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'it-ch': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'de-ch': {
    domain: 'https://www.vistaprint.ie',
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
  'es-us': {
    domain: 'https://www.vistaprint.com',
    proadvantageProgram: true,
    contactUsComponents: ['phone_v2', 'email_v2', 'call_me_v2', 'live_chat_v2'],
  },
}
